import React, { useContext, useRef, useState, useEffect } from 'react';

import styled from 'styled-components';

import Title from '../../components/Title';
import AuthContext from '../../contexts/AuthContext';
import useCafe24Auth from '../../hooks/useCafe24Auth';
import '../../index.css';
import MyPageShopLinkModal from './MyPageShopLinkModal/MyPageShopLinkModal';
import ShopModeContext from '../../contexts/ShopModeContext';
import Cafe24Logo from '../../icons/ic-cafe24-logo.png';
import MakeShopLogo from '../../icons/ic-makeShop-logo.png';
import { getUserDetail, getShopList } from '../../modules/NetworkFunction';

function MyPageShopLink() {
  const [shopVersion, setShopVersion] = useState('');
  const [modalType, setModalType] = useState('');
  const { auth: token } = useContext(AuthContext);
  const [isLoaded, setIsLoaded] = useState(false);
  const [multiShopList, setMultiShopList] = useState([]);
  const [selectedShop, setSelectedShop] = useState();
  const { linkedShop } = useContext(ShopModeContext);
  const cafe24MallId = useState(localStorage.getItem('mallId') || '');

  const [userData, setUserData] = useState(sessionStorage.userData);

  const [makeShopShopURL, setMakeShopShopURL] = useState(
    sessionStorage.userData?.makeshopURL
  );

  const [modalOpen, setModalOpen] = useState(false);

  const query = window.location.search;
  const params = new URLSearchParams(query);
  const cafe24AuthCode = params.get('code');

  useEffect(() => {
    if (cafe24AuthCode) {
      setModalType('shopLink');
      setShopVersion('cafe24');
      setModalOpen(true);
    }
  }, [cafe24AuthCode]);

  const getMultiShopList = () => {
    getShopList(
      {
        mallId: localStorage.getItem('mallId'),
        token: sessionStorage.getItem('accessToken'),
      },
      (shopList) => {
        setMultiShopList(shopList);
      },
      (e) => {
        console.log(e);
      },
      null
    );
  };

  useEffect(() => {
    if (!isLoaded) {
      getUserDetail(
        null,
        (v) => {
          setUserData(v.user);
          setMakeShopShopURL(v.user.makeshopURL);
        },
        setIsLoaded,
        (e) => {
          console.log('getuserdetail', e);
        },
        token
      );
    }
  }, [isLoaded, token]);

  const openModal = (type, shopVersion) => {
    setModalType(type);
    if (type === 'selectShop') {
      setShopVersion('');
      setModalOpen(true);
    } else if (type === 'shopLink') {
      if (shopVersion === 'cafe24') {
        setShopVersion('cafe24');
      } else {
        setShopVersion('makeShop');
      }
      setModalOpen(true);
    }
  };
  const closeModal = () => {
    setModalType('');
    setShopVersion('');
    setModalOpen(false);
  };

  useEffect(() => {
    if (linkedShop === 'cafe24') {
      getMultiShopList();
    } else if (linkedShop === 'makeshop') {
      if (userData) {
        setMakeShopShopURL(userData.makeshopURL);
      }
    } else if (linkedShop === 'both') {
      getMultiShopList();
      if (userData) {
        setMakeShopShopURL(userData.makeshopURL);
      }
    }
  }, [linkedShop]);

  useEffect(() => {
    if (multiShopList.length > 0 && userData) {
      const foundShop = multiShopList.find(
        (shop) => shop.shop_no === userData.shopNo
      );
      if (foundShop) {
        setSelectedShop(foundShop.shop_name);
      }
    }
  }, [multiShopList, userData]);

  return (
    <div style={{ position: 'relative', height: '100%' }}>
      <MyPageShopLinkModal
        modalType={modalType}
        shopVersion={modalType === 'shopLink' ? shopVersion : ''}
        open={modalOpen}
        close={closeModal}
      />
      <Title title="쇼핑몰 관리" />
      <div
        style={{ display: 'flex', flexDirection: 'column', marginTop: 32 }}
        className="inner-box"
      >
        <HeaderContainer>
          <LinkedShopTitle>연동된 쇼핑몰</LinkedShopTitle>
          <AddButton onClick={() => openModal('selectShop')}>
            추가하기
          </AddButton>
        </HeaderContainer>
        {linkedShop === 'both' ? (
          <Column>
            <LinkedShopContainer>
              <LinkedShopLeft>
                <LogoImage src={Cafe24Logo} />
                <LinkComplete>연동완료</LinkComplete>
              </LinkedShopLeft>
              <LinkedShopRight>
                <ShopContentText>{cafe24MallId}</ShopContentText>
                <Line />
                <ShopContentText>{selectedShop}</ShopContentText>
                <UpdateButton onClick={() => openModal('shopLink', 'cafe24')}>
                  변경하기
                </UpdateButton>
              </LinkedShopRight>
            </LinkedShopContainer>
            <LinkedShopContainer>
              <LinkedShopLeft>
                <LogoImage src={MakeShopLogo} />
                <LinkComplete>연동완료</LinkComplete>
              </LinkedShopLeft>
              <LinkedShopRight>
                <ShopContentText>{makeShopShopURL}</ShopContentText>
                <UpdateButton onClick={() => openModal('shopLink', 'makeShop')}>
                  변경하기
                </UpdateButton>
              </LinkedShopRight>
            </LinkedShopContainer>
          </Column>
        ) : (
          <LinkedShopContainer>
            <LinkedShopLeft>
              <LogoImage
                src={
                  linkedShop === 'cafe24'
                    ? Cafe24Logo
                    : linkedShop === 'makeshop'
                    ? MakeShopLogo
                    : null
                }
              />
              <LinkComplete>연동완료</LinkComplete>
            </LinkedShopLeft>
            <LinkedShopRight>
              <ShopContentText>
                {linkedShop === 'cafe24' ? cafe24MallId : makeShopShopURL}
              </ShopContentText>
              {linkedShop === 'cafe24' && (
                <>
                  <Line />
                  <ShopContentText>{selectedShop}</ShopContentText>
                </>
              )}
              <UpdateButton onClick={() => openModal('shopLink', linkedShop)}>
                변경하기
              </UpdateButton>
            </LinkedShopRight>
          </LinkedShopContainer>
        )}
      </div>
    </div>
  );
}

export default MyPageShopLink;

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 42px;
`;

const LinkedShopTitle = styled.div`
  font-size: 20px;
  font-weight: 400;
  text-align: left;
`;

const LinkedShopNoneTitle = styled.div`
  font-size: 28px;
  font-weight: 400;
  text-align: center;
  margin-top: 40px;
  color: #b5b5b5;
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: 16px;
`;

const LinkedShopContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 60px;
  padding: 18px 24px;
  border: 0.5px solid #ccc;
  border-radius: 5px;
`;
const LinkedShopLeft = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  height: 100%;
`;

const LinkedShopRight = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  width: 100%;
  height: 100%;
`;

const LogoImage = styled.img`
  display: inline-block;
  width: 127px;
  height: 24px;
`;

const LinkComplete = styled.div`
  width: 76px;
  height: 28px;
  padding: 2px 10px;
  text-align: center;
  margin-left: 24px;
  border-radius: 30px;
  font-size: 14px;
  font-weight: 400;
  border: 1px solid #ffb600;
  color: #ffb600;
`;

const UpdateButton = styled.div`
  width: 72px;
  height: 28px;
  padding: 4px 10px;
  text-align: center;
  border-radius: 5px;
  font-size: 14px;
  font-weight: 500;
  border-width: 0;
  margin-left: 32px;
  background-color: #b5b5b5;
  color: #fff;
  cursor: pointer;
`;

const AddButton = styled.div`
  text-align: center;
  font-size: 16px;
  font-weight: 400;
  border-width: 0;
  text-decoration: underline;
  color: #ff7a00;
  cursor: pointer;
`;

const Line = styled.div`
  width: 1px;
  height: 23px;
  background-color: #ccc;
`;

const ShopContentText = styled.div`
  font-size: 18px;
  font-weight: 400;
  color: #000;
  max-width: 380px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
